import { ModuleLayout, ModuleType } from "entities/modules/types";
import { getLayoutOptionsByType } from "modules/moduleTemplates/components/ModuleDetailsDrawer/context/utils";

type AssureValidLayoutParams = {
  moduleType: ModuleType | null;
  studioFilterEnabled: boolean;
  moduleLayout: ModuleLayout | null;
  setModuleLayout: (moduleLayout: ModuleLayout | null) => void;
};

export const assureValidLayout = ({
  moduleLayout,
  moduleType,
  setModuleLayout,
  studioFilterEnabled,
}: AssureValidLayoutParams) => {
  if (!moduleType || !moduleLayout) {
    return;
  }

  const allowedLayouts = getLayoutOptionsByType({
    moduleType,
    studioFilterEnabled,
  });
  const invalidLayout = !allowedLayouts.find((l) => l.value === moduleLayout);

  if (invalidLayout) {
    setModuleLayout(null);
  }
};
